import { render, staticRenderFns } from "./DrivewealthChoiceOptionFundsList.vue?vue&type=template&id=136b7928"
import script from "./DrivewealthChoiceOptionFundsList.vue?vue&type=script&lang=ts"
export * from "./DrivewealthChoiceOptionFundsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports